import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FlatButton } from "src/framework/components/buttons";

import { useObservable } from "src/framework/store/storeUtil";
import { IConfirmationDialog, openDialogConfirmation$, setupDialog$ } from "./store";
import "./styles.css";

const Confirmation = () => {
  const open = useObservable<boolean>(openDialogConfirmation$);
  const setup = useObservable<IConfirmationDialog>(setupDialog$)

  return (
    <div>
      <Dialog
        open={open || false}
        onClose={() => {
          setup?.onClose();
        }}
      >
        <DialogTitle id="simple-dialog-title">
          {setup?.title}
        </DialogTitle>
        <DialogContent
          style={{
            minWidth: setup?.size || "300px",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {setup?.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={setup?.fullWidth ? "dialog-actions-responive" : ""} style={setup?.fullWidth ? { display: "flex", flexDirection: "column-reverse", width: "100%", padding: "10px 25px" } : {}}>
          <FlatButton
            onClick={() => {
              if (setup?.onNegation) {
                setup?.onNegation();
              }
              setup?.onClose();
            }}
            variant={setup?.noVariant || "text"}
            color="secondary"
            text={setup?.noText || "Não"}
            fullWidth={setup?.fullWidth || undefined}
          />
          <FlatButton
            onClick={() => {
              if (setup?.onConfirmation) {
                setup?.onConfirmation();
              }
              setup?.onClose();
            }}
            color="primary"
            variant={setup?.yesVariant || "contained"}
            text={setup?.yesText || "Sim"}
            fullWidth={setup?.fullWidth || undefined}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export { Confirmation };
